import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ActionsPlugin from "./plugins/ActionsPlugin";
import ComponentsPlugin from "./plugins/ComponentsPlugin";
import ConstantsPlugin from "./plugins/ConstantsPlugin";
import LodashPlugin from "./plugins/LodashPlugin";
import MomentPlugin from "./plugins/MomentPlugin";
import ServicesPlugin from "./plugins/ServicesPlugin";
import ValidationPlugin from "./plugins/ValidationPlugin";

Vue.config.productionTip = false;

// Global actions
Vue.use(ActionsPlugin);

// Global constants
Vue.use(ConstantsPlugin);

// Global dependencies
Vue.use(LodashPlugin);
Vue.use(MomentPlugin);

// Global components
Vue.use(ComponentsPlugin);

// Global services
Vue.use(ServicesPlugin);

// Validation
Vue.use(ValidationPlugin);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
